module.exports = __webpack_public_path__ + "img/vivian-ian-agami.d4d15c99.png";